module.exports = __webpack_public_path__ + "static/media/user.8f432f78.png";